import React from "react";
import { makeStyles } from 'tss-react/mui';

// core components
import Header from "../components/Header/Header.js";
import Footer from "../components/Footer/Footer.js";
import GridContainer from "../components/Grid/GridContainer.js";
import GridItem from "../components/Grid/GridItem.js";
import Button from "../components/CustomButtons/Button.js";
import HeaderLinks from "../components/Header/HeaderLinks.js";
import Parallax from "../components/Parallax/Parallax.js";
import CustomInput from "../components/CustomInput/CustomInput.js";
import logo from "../public/img/logo.png";

import styles from "../styles/jss/nextjs-material-kit/pages/careerZoneStyle";

// Sections for this page
import ProductSection from "../pages-sections/LandingPage-Sections/ProductSection.js";
import TopJobs from "../pages-sections/LandingPage-Sections/TopJobs.js";
import WeGotYou from "../pages-sections/LandingPage-Sections/WeGotYou.js";
import TeamSection from "../pages-sections/LandingPage-Sections/TeamSection.js";
import NeedAdvice from "../pages-sections/LandingPage-Sections/NeedAdvice.js";
import CareerZoneGrid from "../pages-sections/LandingPage-Sections/CareerZoneGrid.js";
import GetOnBoard from "../pages-sections/LandingPage-Sections/GetOnBoard.js";
import PreFooter from "../pages-sections/LandingPage-Sections/PreFooter.js";
import Head from "next/head";
import {client} from "../request/client";
import useSWR from "swr";
import JSONSchemaData from "../components/JSONSchemaData/JSONSchemaData";

const dashboardRoutes = [];
const logoImg = "<img src=" + logo + "/>";

const useStyles = makeStyles()(styles);

export default function LandingPage(props) {
  const { classes, cx } = useStyles();
  const { ...rest } = props;

  const { data, error, isLoading } = useSWR(`/v1/career_zones`, null, {
    fallbackData: props.fallback,
  });

  const jsonBreadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://successatschool.org/"
    }, {
      "@type": "ListItem",
      "position": 2,
      "name": "Career Zones",
      "item": "https://successatschool.org/career-zones"
    }]};

  return (
    <div className="careerZoneSlide">
      <Header
        color="transparent"
        routes={dashboardRoutes}
        logo={logo}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <Head>
        <link rel="canonical" href="https://successatschool.org/career-zones" />
        <title>Career Zones - Success at School</title>
      </Head>

      <Parallax filter image="/img/faces/careerzone_slide_bg.png">
        <div className={cx(classes.container, "center-data")}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <h1 className={[classes.title, "title"].join(" ")}>
                Career Zones
              </h1>
              <br />
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={cx(classes.main, "mainsitecontainer")}>
        <div className={cx(classes.white_bg, "colored_bgg")}>
          <CareerZoneGrid data={data} />
        </div>
      </div>
      <div className={cx(classes.darkBlue, "footer", "colored_bgg")}>
        <PreFooter />
      </div>
      <Footer />
      <JSONSchemaData key_name={'breadcrumbSchema'} data={jsonBreadcrumbData} />
    </div>
  );
}

export async function getServerSideProps() {
  try {
    const data = await client({
      url: `/v1/career_zones`,
      method: "get",
      headers: {},
    }).then((res) => res.data);

    return {
      props: {
        fallback: data,
      }
    };
  }
  catch (e) {
    if (e.response && e.response.status === 404) {
      return {
        notFound: true,
      };
    }
    else {
      throw e;
    }
  }
}
